export default "__VITE_ASSET__C8C0Ep5Y__"